<app-custom-range-panel
  [customPresets]="pickerService.customPresets"
></app-custom-range-panel>
<mat-calendar-header></mat-calendar-header>
